// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".filters-modal[data-v-a51766da]{border-radius:15px}.filters-modal__filters[data-v-a51766da]{display:grid;grid-template-columns:1fr 1fr;max-width:100%;max-height:320px;overflow:auto}@media(max-width:767px){.filters-modal__filters[data-v-a51766da]{grid-template-columns:1fr}}.filters-modal__body[data-v-a51766da]{overflow:hidden;min-height:420px;gap:10px;border-bottom-left-radius:0!important;border-bottom-right-radius:0!important}", ""]);
// Exports
module.exports = exports;
